export default {
  placeholder: 'Suche Geschäft...',
};
